<template>
  <vonap-promised :promise="loadPromise" v-slot="{data}">
    <div>
      <vonap-window
        transition="dialog-scale-transition"
        v-model="showCopyFromDialog"
        title="Copy Configuration From"
        width="500px"
        :modal="true"
      >
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <vonap-form-label label="Copy From">
                    <kendo-dropdownlist
                      style="width:100%"
                      :data-source="fromDataSource"
                      :data-text-field="'name'"
                      :data-value-field="'clientId'"
                      :filter="'contains'"
                      :options-label="'Copy From'"
                      v-model="firstClientId"
                    >
                    </kendo-dropdownlist>
                  </vonap-form-label>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="currentClient" label="To" disabled></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small color="blue primary" @click="copyConfiguration" title="Copy Configuration"
              ><v-icon>check</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </vonap-window>

      <v-card>
        <v-toolbar card color="#1e355e" dark>
          <v-toolbar-items>
            <v-toolbar-title>Finstar Modules</v-toolbar-title>
            <kendo-dropdownlist
              :data-source="assignedMarkets"
              v-model="selectedMarket"
            ></kendo-dropdownlist>
            <v-btn v-if="!isMaster" @click="openCopyModal" flat title="Copy Configuration From">
              <v-icon>file_copy</v-icon>
              Copy
            </v-btn>
            <v-btn @click="checkAllToggle" flat title="Uncheck All">
              <v-icon v-if="!allItemsChecked">check_box_outline_blank</v-icon>
              <v-icon v-else flat>check_box</v-icon> {{ checkAllButtonText }}
            </v-btn>
            <v-btn @click="save" flat>
              <v-icon>check</v-icon>
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-tabs v-model="CurrentTab" light icons-and-text>
          <v-tab v-for="item in tabs" :key="item.index" :href="'#tab-' + item.index">
            {{ item.folder }}
            <v-icon>{{ item.icon }}</v-icon>
          </v-tab>
          <v-tabs-items v-model="CurrentTab">
            <v-tab-item v-for="item in tabs" :key="item.index" :value="'tab-' + item.index">
              <v-card>
                <v-container fluid grid-list-sm class="py-2">
                  <v-layout row justify-center wrap>
                    <v-flex xs12 sm6 md4 lg3 v-for="path in tabItems" v-bind:key="path.name">
                      <v-card>
                        <v-card-title primary-title class="py-0">
                          <v-switch
                            v-model="path.enable"
                            class="mt-0 configSwitch"
                            :label="path.name"
                          >
                          </v-switch>
                        </v-card-title>
                        <v-card-text class="py-0">
                          <v-text-field
                            :prepend-inner-icon="path.icon"
                            v-model="path.text"
                          ></v-text-field>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </div>
  </vonap-promised>
</template>
<script>
import {mapGetters} from 'vuex'
import notification from '@/helpers/notification'
import VonapWindow from '@/components/VonapWindow'
import VonapFormLabel from '@/components/VonapFormLabel'
import VonapPromised from '@/components/VonapPromised'
import axios from 'axios'
import sitemap from '@/sitemap'
import {folderIcons} from '@/helpers/menu-helpers'
import store from '../store'

export default {
  name: 'ApplicationConfiguration',
  components: {
    VonapFormLabel,
    VonapWindow,
    VonapPromised,
  },
  mounted() {
    this.loadPromise = this.readApplicationPaths()
  },
  data() {
    return {
      loadPromise: null,
      selectedMarket: 'All',
      SystemPaths: ['home', 'login', 'application-configuration'],
      CurrentTab: 'tab-0',
      showCopyFromDialog: false,
      applicationPaths: {},
      applicationUserPaths: {},
      paths: [],
      currentClient: 'Foo',
      firstClientId: 0,
      fromDataSource: new kendo.data.DataSource({
        data: [],
        schema: {
          model: {
            fields: {
              clientId: {type: 'number'},
              name: {type: 'string'},
            },
          },
        },
      }),
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({userClientMarkets: 'authentication/userClientMarkets'}),
    isMaster: function() {
      return this.clientId == 0
    },
    tabs: function() {
      return [...new Set(this.visibleItemsForMarket.map(x => x.folder.toUpperCase()))].map(
        (folder, i) => ({
          tab: 'tab-' + i,
          index: i,
          icon: folderIcons[folder],
          folder,
        }),
      )
    },
    tabItems: function() {
      let tab = this.tabs.find(f => f.tab == this.CurrentTab)
      if (!tab) {
        const [firstTab] = this.tabs
        tab = firstTab
      }

      let folder = 'list'
      if (tab) {
        folder = tab.folder.toLowerCase()
      }
      return this.visibleItemsForMarket.filter(el => el.folder == folder)
    },
    visibleItems() {
      if (this.clientId == 0) {
        return this.paths
      } else {
        return this.paths.filter(el => this.isPathEnabledForMaster(el.path))
      }
    },
    visibleItemsForModule() {
      return this.visibleItems.filter(x => {
        return this.selectedMarket == 'All' || x.module == this.selectedMarket
      })
    },
    visibleItemsForMarket() {
      const marketCodes = Object.keys(this.clientMarkets)
      return this.selectedMarket == 'All'
        ? this.visibleItems.filter(
            x => x.markets && marketCodes.some(r => Object.keys(x.markets).includes(r)),
          )
        : this.visibleItems.filter(
            x => x.markets && Object.keys(x.markets).includes(this.selectedMarket),
          )
    },
    clientMarkets() {
      let clientMarkets = this.userClientMarkets.reduce((acc, item) => {
        acc[item.market] = item.marketId
        return acc
      }, {})

      return clientMarkets
    },
    allItemsChecked: function() {
      const allChecked = this.tabItems.every(el => el.enable)
      return allChecked
    },
    checkAllButtonText: function() {
      if (this.allItemsChecked) return 'Uncheck All'

      return 'Check All'
    },
    modules() {
      return ['All', ...new Set(this.paths.filter(item => item.module).map(item => item.module))]
    },
    assignedMarkets() {
      return [
        'All',
        ...new Set(this.userClientMarkets.filter(x => x.marketId >= 0).map(item => item.market)),
      ]
    },
  },
  methods: {
    checkAllToggle: function() {
      const checkValue = !this.allItemsChecked
      this.tabItems.forEach(el => (el.enable = checkValue))
    },
    copyConfiguration: function() {
      axios
        .post('/api/ApplicationConfiguration/copyConfiguration', {
          clientId: +this.clientId,
          fromClientId: +this.firstClientId,
        })
        .then(response => {
          if (response.status == 200) {
            //this.$emit('save')
            let responseType = response.headers['content-type']
            if (responseType.includes('application/json')) {
              let parseResponse = response.data
              if (parseResponse.message) {
                notification(parseResponse.message)
                this.readApplicationPaths()
                this.closeCopyModal()
                store.dispatch('app/setClientConfiguration', {selectedClientId: +this.clientId})
              }
            }
          }
        })
        .catch(() => notification('Some error', 'error'))
    },
    getClients: async function() {
      const req = await axios
        .get('/api/config/client/getOtherClients', {
          params: {
            clientId: this.clientId,
          },
        })
        .catch(() => notification('Error', 'error'))
      let data = req.data
      //this.clients = data.clients
      this.fromDataSource.data(data.clients)
      this.currentClient = data.currentClient
      //this.firstClientId = data.clientId
      this.showCopyFromDialog = true
    },
    openCopyModal: function() {
      this.getClients()
    },
    closeCopyModal: function() {
      this.showCopyFromDialog = false
    },
    isPathEnabled: function(search) {
      const foundItem = this.applicationPaths.filter(item => item.path == search)
      const isEnabled = foundItem.length > 0 && foundItem[0].enable
      return isEnabled
    },
    isPathEnabledForMaster: function(search) {
      const foundItem = this.applicationPaths.filter(
        item => item.path == search && item.clientId == 0 && item.enable,
      )
      const isEnabled = foundItem.length > 0
      return isEnabled
    },
    isPathEnabledForClient: function(search) {
      const foundItem = this.applicationUserPaths.filter(
        item => item.path == search && item.clientId == this.clientId && item.enable,
      )
      const isEnabled = foundItem.length > 0
      return isEnabled
    },
    masterPathText: function(search, originalText) {
      const foundItem = this.applicationPaths.filter(
        item => item.path == search && item.clientId == this.clientId && item.enable,
      )
      const text =
        foundItem.length > 0 && foundItem[0].text != null ? foundItem[0].text : originalText
      return text
    },
    clientPathText: function(search, originalText) {
      const foundItem = this.applicationUserPaths.filter(
        item => item.path == search && item.clientId == this.clientId && item.enable,
      )
      const text =
        foundItem.length > 0
          ? foundItem[0].text != null
            ? foundItem[0].text
            : this.masterPathText(search, originalText)
          : originalText
      return text
    },
    readSitemap: function() {
      const paths = sitemap
        .filter(el => !this.SystemPaths.includes(el.name))
        .map(({meta, path, name}) => {
          const [, folder] = path.match(/\/(.*)\//)
          return {
            text: this.clientPathText(path, meta.text),
            path: path,
            icon: meta.icon,
            module: meta.module,
            markets: meta.markets,
            name: name,
            folder,
            folderIcon: folderIcons[folder.toUpperCase()],
            enable:
              this.clientId == 0 ? this.isPathEnabled(path) : this.isPathEnabledForClient(path),
          }
        })
      this.paths = paths
    },
    readApplicationPaths: async function() {
      const response = await axios.get(
        '/api/ApplicationConfiguration/getApplicationPaths?clientId=' + this.clientId,
      )

      if (response.status == 200) {
        this.applicationUserPaths = response.data

        const masterApplicationPaths = await axios.get(
          '/api/ApplicationConfiguration/readMasterApplicationPaths',
        )
        if (masterApplicationPaths.status == 200) {
          this.applicationPaths = masterApplicationPaths.data
          this.readSitemap()
        }
      }
    },
    save: function() {
      axios
        .put('/api/ApplicationConfiguration/putApplicationPaths', {
          paths: this.paths,
          clientId: this.clientId,
        })
        .then(res => {
          if (res.status == 200) {
            store.dispatch('app/setClientConfiguration', {selectedClientId: this.clientId})
          }
        })
        .catch(() => notification('Some error ocurred saving', 'error'))
    },
  },
}
</script>

<style>
.configSwitch > div > div > label {
  font-weight: normal !important;
  font-size: 12px !important;
}
.configSwitch > div > div.v-messages {
  display: none !important;
}
.configSwitch > div > div.v-input__slot {
  margin-bottom: 0px !important;
}
</style>
